import { KTextField } from "kinnect-general";
import { formatCurrency } from "kinnect-formatters";
import {
	VCard,
	VCardText,
	VCardTitle,
	VDivider,
	VSpacer
} from "vuetify/lib";

export default {
	name: "BonusCalculator",

	props: {
		pointValue: Number
	},

	data: vm => ( {
		formFields: {
			employeeUnitTotal: null,
			pointValue: vm.pointValue
		}
	} ),

	computed: {
		estimatedBonus() {
			if ( this.formFields.pointValue && this.formFields.employeeUnitTotal ) {
				return formatCurrency( this.formFields.pointValue * this.formFields.employeeUnitTotal );
			}

			return null;
		}
	},

	render() {
		return <VCard>
			<VCardTitle class="primary white--text">
				Estimated Bonus Calculator
			</VCardTitle>

			<VSpacer></VSpacer>

			<VCardText>
				<KTextField
					hint={this.formFields.pointValue
						? `${formatCurrency( parseFloat( this.formFields.pointValue ) )} / point`
						: ""
					}
					label="Point Value"
					type="number"
					vModel={this.formFields.pointValue}
					validationName="point value"
					validationRules="money"
				></KTextField>

				<KTextField
					hint="You can request your current EUT from the HR department"
					label="Employee Unit Total (EUT)"
					type="number"
					persistentHint
					vModel={this.formFields.employeeUnitTotal}
					validationName="employee unit total"
					validationRules="min_value:0"
				></KTextField>

				<VDivider class="my-4"></VDivider>

				<p class="text-h6">
					Your Estimated Quarterly Bonus is:
				</p>

				<p class="text-h5">
					{this.estimatedBonus ? this.estimatedBonus : "..."}
				</p>
			</VCardText>
		</VCard>;
	}
};
